import NearbyPickUpLocations from './NearbyPickUpLocations';

export default NearbyPickUpLocations;
